import {
  NgModule,
} from '@angular/core';

import {
  MatSnackBarModule,
} from '@angular/material/snack-bar';

import {
  notificationProvider,
} from './notification.provider';

export const MATERIAL_MODULES = [
  MatSnackBarModule,
];


@NgModule({
  imports: [MATERIAL_MODULES],

  declarations: [],

  exports: [],

  providers: [
    notificationProvider,
  ],
})
export class NotificationModule { }
